import React from 'react';
import useMemo from '@/util/hook/useMemo';
import { BUTTON_SIZE } from '@/config/ui/button';
import { SEMANTIC_COLORS } from '@/constant/unit/color';
import { BackButton, ForwardButton, MinusButton, PlusButton } from '../../component/atom/Button';
import { NextButton, PrevButton } from '../../component/atom/Button/PrevNextButton';
import ChoiceChip from '../../component/atom/ChoiceChip';
import Header from '../../component/atom/Header';
import { ChevronRight, Dollar } from '../../component/atom/Icon';
import InfiniteCarousel from '../../component/composite/InfiniteCarousel';
import RWDPageLayout from '../../component/composite/RWDPageLayout';
import AllDayExpectedStartTimePopup from '../../popup/AllDayExpectedStartTime';
import PartTimeTimeSlotListPopup from '../../popup/PartTimeTimeSlotList';
import { S } from './style';
import { APP } from '../../config/app';
const renderHeader = () => (<Header progress={APP.PAGE_PROGRESS_INFO['/dateAndTime'].progress} progressTitle={APP.PAGE_PROGRESS_INFO['/dateAndTime'].title}/>);
const renderCareOrderPlanSelectionSection = ({ careOrderPlanKey, careOrderPlanOptionList, handleCarouselActiveItemChange, }) => {
    if (!careOrderPlanOptionList.length)
        return null;
    if (careOrderPlanOptionList.length === 1) {
        const careOrderPlanOption = careOrderPlanOptionList[0];
        return (<S.LayoutSection>
        <S.SectionTitle>您選擇的方案</S.SectionTitle>
        <S.LayoutSingleSlideCard>
          <S.SlideCard data={careOrderPlanOption.key}>
            <S.LayoutSlideCardContent>
              <S.LayoutSlideCardBody>
                <strong>{careOrderPlanOption.displayTitle}</strong>
                <span>{careOrderPlanOption.description}</span>
              </S.LayoutSlideCardBody>
              <S.LayoutSlideCardFooter>
                <Dollar style={{
                width: '22px',
                height: '22px',
                marginRight: '3px',
                color: SEMANTIC_COLORS.PRIMARY_ICON,
            }}/>
                {careOrderPlanOption.parsedFee}
              </S.LayoutSlideCardFooter>
            </S.LayoutSlideCardContent>
          </S.SlideCard>
        </S.LayoutSingleSlideCard>
      </S.LayoutSection>);
    }
    const items = careOrderPlanOptionList.map((careOrderPlanOption) => {
        if (!careOrderPlanOption)
            return [];
        return (<S.SlideCard key={careOrderPlanOption.key} data={careOrderPlanOption.key}>
        <S.LayoutSlideCardContent>
          <S.LayoutSlideCardBody>
            <strong>{careOrderPlanOption.displayTitle}</strong>
            <span>{careOrderPlanOption.description}</span>
          </S.LayoutSlideCardBody>
          <S.LayoutSlideCardFooter>
            <Dollar style={{
                width: '22px',
                height: '22px',
                marginRight: '3px',
                color: SEMANTIC_COLORS.PRIMARY_ICON,
            }}/>
            {careOrderPlanOption.parsedFee}
          </S.LayoutSlideCardFooter>
        </S.LayoutSlideCardContent>
      </S.SlideCard>);
    });
    const defaultActiveItem = careOrderPlanOptionList.find((option) => option.key === careOrderPlanKey);
    const defaultActiveItemIndex = defaultActiveItem
        ? careOrderPlanOptionList.indexOf(defaultActiveItem)
        : undefined;
    return (<S.LayoutSection>
      <S.SectionTitle>您選擇的方案</S.SectionTitle>
      <S.LayoutInfiniteCarousel>
        <InfiniteCarousel items={items} defaultActiveItemIndex={defaultActiveItemIndex} handleActiveItemChange={({ current, prev }) => handleCarouselActiveItemChange({ current, prev })}/>
      </S.LayoutInfiniteCarousel>
    </S.LayoutSection>);
};
const renderAllDayTimeSelectionSection = ({ isAsap, parsedAllDayExpectedStartTime, parsedAllDayExpectedServiceDays, handleIsAsapChoiceChipClick, handleAllDayExpectedStartTimeFieldClick, handleAllDayExpectedServiceDaysUpdate, getCanSubtractAllDayExpectedServiceDays, getCanAddAllDayExpectedServiceDays, }) => {
    const isSectionDisabled = isAsap === null;
    return (<>
      <S.LayoutSection>
        <S.SectionTitle>希望照服員抵達的時間</S.SectionTitle>
        <S.LayoutTwoColGrid>
          <ChoiceChip isSelected={isAsap === true} content='越快越好' onChipClick={() => handleIsAsapChoiceChipClick({ isAsap: true })}/>
          <ChoiceChip isSelected={isAsap === false} content='預約時間' onChipClick={() => handleIsAsapChoiceChipClick({ isAsap: false })}/>
        </S.LayoutTwoColGrid>

        {isAsap === false ? (<S.LayoutFieldBox onClick={handleAllDayExpectedStartTimeFieldClick}>
            <S.FieldBox>
              <S.FieldBoxValue hasValue={!!parsedAllDayExpectedStartTime}>
                {parsedAllDayExpectedStartTime || '請選擇時間'}
              </S.FieldBoxValue>
              <ChevronRight color={SEMANTIC_COLORS.SECONDARY_ICON} size='30px'/>
            </S.FieldBox>
          </S.LayoutFieldBox>) : null}
      </S.LayoutSection>
      <S.LayoutSection isLast>
        <S.SectionTitle>需要照服員服務幾天</S.SectionTitle>
        <S.LayoutCounterButtons isDisabled={isSectionDisabled}>
          <MinusButton size='25px' color={SEMANTIC_COLORS.DEFAULT_COUNTER_BUTTON_BACKGROUND} isDisabled={isSectionDisabled || !getCanSubtractAllDayExpectedServiceDays()} onButtonClick={() => handleAllDayExpectedServiceDaysUpdate({ doAdd: false })}/>
          <span>{parsedAllDayExpectedServiceDays}</span>
          <PlusButton size='25px' color={SEMANTIC_COLORS.DEFAULT_COUNTER_BUTTON_BACKGROUND} isDisabled={isSectionDisabled || !getCanAddAllDayExpectedServiceDays()} onButtonClick={() => handleAllDayExpectedServiceDaysUpdate({ doAdd: true })}/>
        </S.LayoutCounterButtons>
      </S.LayoutSection>
    </>);
};
const renderPartTimeTimeSelectionSection = ({ parsedPartTimeExpectedStartTime, parsedPartTimeExpectedEndTime, parsedPartTimeTimeSlotList, handlePartTimeExpectedStartTimeUpdate, getCanSubtractPartTimeExpectedStartTime, getCanAddPartTimeExpectedStartTime, handlePartTimeExpectedStartTimeFieldClick, }) => (<S.LayoutSection isLast>
    <S.SectionTitle>選擇每天服務開始時間</S.SectionTitle>
    <S.LayoutPrevNextButtons>
      <PrevButton isDisabled={!getCanSubtractPartTimeExpectedStartTime()} onButtonClick={() => handlePartTimeExpectedStartTimeUpdate({ doAdd: false })}/>
      <span>{parsedPartTimeExpectedStartTime}</span>
      <NextButton isDisabled={!getCanAddPartTimeExpectedStartTime()} onButtonClick={() => handlePartTimeExpectedStartTimeUpdate({ doAdd: true })}/>
    </S.LayoutPrevNextButtons>
    <S.LayoutPartTimeTimeSlotDisplay>
      {parsedPartTimeExpectedStartTime} <span>～</span> {parsedPartTimeExpectedEndTime}
    </S.LayoutPartTimeTimeSlotDisplay>
    <S.LayoutFieldBox onClick={handlePartTimeExpectedStartTimeFieldClick}>
      <S.FieldBox>
        <S.FieldBoxValue hasValue={!!parsedPartTimeTimeSlotList}>
          {parsedPartTimeTimeSlotList || '請選擇服務日期'}
        </S.FieldBoxValue>
        <ChevronRight color={SEMANTIC_COLORS.SECONDARY_ICON} size='30px'/>
      </S.FieldBox>
    </S.LayoutFieldBox>
  </S.LayoutSection>);
const renderFooter = ({ handleBackButtonClick, handleForwardButtonClick, isForwardButtonAvailable, }) => (<S.LayoutFooter>
    <BackButton isAvailable size={BUTTON_SIZE.LARGE} onButtonClick={handleBackButtonClick}>
      上一步
    </BackButton>
    <S.GapRow width={40}/>
    <ForwardButton size={BUTTON_SIZE.LARGE} onButtonClick={handleForwardButtonClick} isAvailable={isForwardButtonAvailable}>
      下一步
    </ForwardButton>
  </S.LayoutFooter>);
const renderPopups = ({ popupType, setPopupType, partTimeTimeSlotOptionList, }) => (<>
    <AllDayExpectedStartTimePopup popupType={popupType} setPopupType={setPopupType}/>
    <PartTimeTimeSlotListPopup popupType={popupType} setPopupType={setPopupType} partTimeTimeSlotOptionList={partTimeTimeSlotOptionList}/>
  </>);
export default function View({ 
// data
isLoading, isAsap, isAllDay, careOrderPlanKey, careOrderPlanOptionList, careOrderBabyFormForDateAndTimePage, isForwardButtonAvailable, popupType, partTimeTimeSlotOptionList, 
// func
setPopupType, handleCarouselActiveItemChange, handleIsAsapChoiceChipClick, handleAllDayExpectedStartTimeFieldClick, handleAllDayExpectedServiceDaysUpdate, getCanSubtractAllDayExpectedServiceDays, getCanAddAllDayExpectedServiceDays, handlePartTimeExpectedStartTimeUpdate, getCanSubtractPartTimeExpectedStartTime, getCanAddPartTimeExpectedStartTime, handlePartTimeExpectedStartTimeFieldClick, handleBackButtonClick, handleForwardButtonClick, }) {
    const header = useMemo(() => renderHeader(), []);
    // #NOTES
    // re-render InfiniteCarousel only when the `careOrderPlanOptionList` changes
    const careOrderPlanSelectionSection = useMemo(() => renderCareOrderPlanSelectionSection({
        careOrderPlanKey,
        careOrderPlanOptionList,
        handleCarouselActiveItemChange,
    }), [careOrderPlanOptionList]);
    const allDayTimeSelectionSection = useMemo(() => renderAllDayTimeSelectionSection({
        isAsap,
        parsedAllDayExpectedStartTime: careOrderBabyFormForDateAndTimePage.parsedAllDayExpectedStartTime,
        parsedAllDayExpectedServiceDays: careOrderBabyFormForDateAndTimePage.parsedAllDayExpectedServiceDays,
        handleIsAsapChoiceChipClick,
        handleAllDayExpectedStartTimeFieldClick,
        handleAllDayExpectedServiceDaysUpdate,
        getCanSubtractAllDayExpectedServiceDays,
        getCanAddAllDayExpectedServiceDays,
    }), [
        isAsap,
        careOrderBabyFormForDateAndTimePage.parsedAllDayExpectedStartTime,
        careOrderBabyFormForDateAndTimePage.parsedAllDayExpectedServiceDays,
        handleIsAsapChoiceChipClick,
        handleAllDayExpectedStartTimeFieldClick,
        handleAllDayExpectedServiceDaysUpdate,
        getCanSubtractAllDayExpectedServiceDays,
        getCanAddAllDayExpectedServiceDays,
    ]);
    const partTimeTimeSelectionSection = useMemo(() => renderPartTimeTimeSelectionSection({
        parsedPartTimeExpectedStartTime: careOrderBabyFormForDateAndTimePage.parsedPartTimeExpectedStartTime,
        parsedPartTimeExpectedEndTime: careOrderBabyFormForDateAndTimePage.parsedPartTimeExpectedEndTime,
        parsedPartTimeTimeSlotList: careOrderBabyFormForDateAndTimePage.parsedPartTimeTimeSlotList,
        handlePartTimeExpectedStartTimeUpdate,
        getCanSubtractPartTimeExpectedStartTime,
        getCanAddPartTimeExpectedStartTime,
        handlePartTimeExpectedStartTimeFieldClick,
    }), [
        careOrderBabyFormForDateAndTimePage.parsedPartTimeExpectedStartTime,
        careOrderBabyFormForDateAndTimePage.parsedPartTimeExpectedEndTime,
        careOrderBabyFormForDateAndTimePage.parsedPartTimeTimeSlotList,
        handlePartTimeExpectedStartTimeUpdate,
        getCanSubtractPartTimeExpectedStartTime,
        getCanAddPartTimeExpectedStartTime,
        handlePartTimeExpectedStartTimeFieldClick,
    ]);
    const timeSelectionSection = isAllDay ? allDayTimeSelectionSection : partTimeTimeSelectionSection;
    const footer = useMemo(() => renderFooter({
        handleBackButtonClick,
        handleForwardButtonClick,
        isForwardButtonAvailable,
    }), [isForwardButtonAvailable, handleBackButtonClick, handleForwardButtonClick]);
    const popups = useMemo(() => renderPopups({
        popupType,
        setPopupType,
        partTimeTimeSlotOptionList,
    }), [popupType, partTimeTimeSlotOptionList]);
    return (<RWDPageLayout isLoading={isLoading}>
      {popups}
      {header}
      <S.Layout>
        <S.LayoutPageBody>
          {careOrderPlanSelectionSection}
          {timeSelectionSection}
          {footer}
        </S.LayoutPageBody>
      </S.Layout>
    </RWDPageLayout>);
}
